<script setup lang="ts">
import WelcomeItem from "./WelcomeItem.vue";
import DocumentationIcon from "./icons/IconDocumentation.vue";
import EcosystemIcon from "./icons/IconEcosystem.vue";
import CommunityIcon from "./icons/IconCommunity.vue";
import { RouterLink } from "vue-router";
const mailing_list = `${process.env.VUE_APP_MAILING_LIST_EMAIL}`;
</script>

<template>
  <p class="border h-full p-8 shadow p-4 rounded-3">
    PICNIC (Proteins Involved in CoNdensates In Cells) is machine learning-based
    model that predicts proteins involved in biomolecular condensates. The first
    model (PICNIC) is based on sequence-based features and structure-based
    features derived from Alphafold2 models. Another model includes extended set
    of features based on Gene Ontology terms (PICNIC-GO). Although this model is
    biased by the already available annotations on proteins, it provides useful
    insights about specific protein properties that are enriched in proteins of
    biomolecular condensate. Overall, we recommend using PICNIC that is an
    unbiased predictor, and using PICNIC-GO for specific cases, for example for
    experimental hypothesis generation. <br />
    <RouterLink class="btn btn-sm btn-primary mt-2" to="/about-us"
      >Read more</RouterLink
    >
  </p>
  <WelcomeItem>
    <template #icon>
      <DocumentationIcon />
    </template>
    <template #heading>Documentation</template>

    PICNIC's source code is available in
    <a
      href="https://git.mpi-cbg.de/tothpetroczylab/picnic"
      target="_blank"
      rel="noopener"
      >Gitlab repository</a
    >
    and the publication can be found
    <a
      href="https://doi.org/10.1038/s41467-024-55089-x"
      target="_blank"
      rel="noopener noreferrer"
      >here</a
    >.
  </WelcomeItem>

  <WelcomeItem>
    <template #icon>
      <EcosystemIcon />
    </template>
    <template #heading>Condensate ecosystem</template>

    We strongly support the condensate ecosystem:
    <a href="https://cd-code.org/" target="_blank" rel="noopener">CD-CODE</a>,
    <a href="https://dresdencondensates.org/" target="_blank" rel="noopener"
      >Dresden Condensates</a
    >.
  </WelcomeItem>

  <WelcomeItem>
    <template #icon>
      <CommunityIcon />
    </template>
    <template #heading>Contact us</template>

    Any question? Please get in touch
    <a :href="'mailto:' + mailing_list">{{ mailing_list }}</a
    >.
  </WelcomeItem>
</template>
